import { gql } from '@apollo/client'

export const GET_LEGAL_CONTENT = gql`
  query GetLegalContent {
    legalContent
  }
`
